module.exports = __webpack_public_path__ + "media/images/flags/16/Lebanon-fa8b86bf01fb103b735194cda9e80ed2.png";